export default __webpack_public_path__ + "static/media/clickativo-logo.ef83dad6.png";